import { useCallback } from "react";
import { useAlert } from "@/context/AlertContext";

export const useResponseErrorAlert = () => {
  const alert = useAlert();

  return useCallback(
    (error: any) => alert("error", error, error?.response?.data?.status),
    [alert]
  );
};
